import { render } from "./ProjectNew.vue?vue&type=template&id=47db84e7"
import script from "./ProjectNew.vue?vue&type=script&lang=js"
export * from "./ProjectNew.vue?vue&type=script&lang=js"
script.render = render

export default script